import { withServiceType } from "../serviceRules";
import { Field, setField } from "../SuperAdminCommon";
import { btnBlackStyle, inputStyle, toggleButtonStyle } from "../superAdminStyles";

const rowGridStyle = { display: "grid", gridTemplateColumns: "1.1fr 1fr 1fr 1fr auto", gap: "8px", alignItems: "end" };

function ServiceTypeOptions({ options }) {
    return options.map(option => <option key={option.value} value={option.value}>{option.label}</option>);
}

function onPasswordBlur(service, patchService) {
    return e => {
        if (e.target.value) {
            patchService(service, { mailPassword: e.target.value });
            e.target.value = "";
        }
    };
}

export function ServiceRow({ service, typeOptions, patchService }) {
    const patchOnBlur = field => e => patchService(service, { [field]: e.target.value });
    return (
        <div style={{ ...rowGridStyle, padding: "10px", border: "1px solid #e2e8f0", borderRadius: "8px", background: "white" }}>
            <Field label="Nom du service">
                <input style={inputStyle} defaultValue={service.name} onBlur={patchOnBlur("name")} />
            </Field>
            <Field label="Type">
                <select style={inputStyle} defaultValue={service.type} onChange={e => patchService(service, { type: e.target.value })}>
                    <ServiceTypeOptions options={typeOptions} />
                </select>
            </Field>
            <Field label="Adresse mail">
                <input style={inputStyle} type="email" defaultValue={service.email ?? ""} onBlur={patchOnBlur("email")} />
            </Field>
            <Field label="Serveur IMAP">
                <input style={inputStyle} list="mail-hosts" defaultValue={service.mailHost ?? ""} placeholder="imap.gmail.com" onBlur={patchOnBlur("mailHost")} />
            </Field>
            <button type="button" onClick={() => patchService(service, { active: !service.active })} style={toggleButtonStyle(service.active)}>
                {service.active ? "Désactiver" : "Activer"}
            </button>
            <div style={{ gridColumn: "1 / -1", display: "grid", gridTemplateColumns: "1fr auto", gap: "8px", alignItems: "end" }}>
                <Field label="Nouveau mot de passe d'application" hint="vide = conserver">
                    <input style={inputStyle} type="password" placeholder={service.mailConfigured ? "Mot de passe configuré" : ""} onBlur={onPasswordBlur(service, patchService)} autoComplete="new-password" />
                </Field>
                <span style={{ fontSize: "12px", color: service.mailConfigured ? "#15803d" : "#9ca3af", fontWeight: 600, paddingBottom: "10px" }}>
                    {service.mailConfigured ? "Mail configuré" : "Mail non configuré"}
                </span>
            </div>
        </div>
    );
}

export function ServiceCreateRow({ form, setForm, saving, typeOptions, createService }) {
    return (
        <div
            onKeyDown={e => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    createService();
                }
            }}
            style={{ ...rowGridStyle, padding: "12px", border: "1px dashed #cbd5e1", borderRadius: "8px", background: "#f8fafc" }}
        >
            <Field label="Nom du service">
                <input style={inputStyle} value={form.name} onChange={setField(setForm, "name")} required />
            </Field>
            <Field label="Type">
                <select style={inputStyle} value={form.type} onChange={e => {
                    const type = e.target.value;
                    setForm(f => withServiceType(f, type));
                }}>
                    <ServiceTypeOptions options={typeOptions} />
                </select>
            </Field>
            <Field label="Adresse mail">
                <input style={inputStyle} type="email" value={form.email} onChange={setField(setForm, "email")} />
            </Field>
            <Field label="Serveur IMAP">
                <input style={inputStyle} list="mail-hosts" placeholder="imap.gmail.com" value={form.mailHost} onChange={setField(setForm, "mailHost")} />
            </Field>
            <button type="button" onClick={createService} disabled={saving || !form.name.trim()} style={btnBlackStyle}>{saving ? "Ajout..." : "Ajouter"}</button>
            <div style={{ gridColumn: "1 / -1" }}>
                <Field label="Mot de passe d'application">
                    <input style={inputStyle} type="password" value={form.mailPassword} onChange={setField(setForm, "mailPassword")} autoComplete="new-password" />
                </Field>
            </div>
        </div>
    );
}
